import { render, staticRenderFns } from "./InvitationsPage.vue?vue&type=template&id=5856b92f&"
import script from "./InvitationsPage.vue?vue&type=script&lang=js&"
export * from "./InvitationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports